import { Separator } from '@/components/ui/separator';
import { Mail, Phone, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid="footer" className="section-spacing pb-5 sm:pb-5">
      <div className="section-container">
        {/* Dark rounded container — same style as hero but no background photo */}
        <div className="rounded-[28px] bg-gradient-to-b from-[hsl(150,12%,20%)] via-[hsl(148,11%,19%)] to-[hsl(150,12%,17%)] px-5 sm:px-12 lg:px-16 py-10 sm:py-16 relative overflow-hidden">
          {/* Subtle radial glow */}
          <div className="absolute top-0 left-1/3 w-[500px] h-[300px] bg-[radial-gradient(circle,_rgba(255,255,255,0.04)_0%,_transparent_65%)] pointer-events-none" />

          <div className="relative z-10">
            {/* 3-column grid with strict alignment */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-12 items-start">
              {/* Column 1: Brand */}
              <div>
                <span className="font-display text-lg text-white block mb-0">
                  TenderAI
                </span>
                {/* Invisible spacer to match CONTACT/LEGAL heading height + margin */}
                <p className="text-xs font-medium uppercase tracking-wider mb-5 mt-3.5 opacity-0 pointer-events-none select-none" aria-hidden="true">
                  Spacer
                </p>
                <p className="text-xs text-white/60 leading-relaxed mt-0 mb-0">
                  AI-powered tender review and<br />bid intelligence for procurement teams.
                </p>
              </div>

              {/* Column 2: Contact */}
              <div>
                <p className="text-xs font-medium text-white uppercase tracking-wider mb-5 mt-0">
                  Contact
                </p>
                <ul className="space-y-3.5 mt-0 mb-0 list-none p-0">
                  <li className="mt-0">
                    <a 
                      href="mailto:info@smarttenderai.com"
                      className="flex items-center gap-2 text-xs text-white/60 hover:text-white/90 transition-colors duration-200"
                    >
                      <Mail className="w-3.5 h-3.5 flex-shrink-0" />
                      <span>info@smarttenderai.com</span>
                    </a>
                  </li>
                  <li className="mt-0">
                    <a 
                      href="tel:+442039760700"
                      className="flex items-center gap-2 text-xs text-white/60 hover:text-white/90 transition-colors duration-200"
                    >
                      <Phone className="w-3.5 h-3.5 flex-shrink-0" />
                      <span>+44 20 3976 0700</span>
                    </a>
                  </li>
                  <li className="mt-0">
                    <div className="flex items-start gap-2 text-xs text-white/60">
                      <MapPin className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" />
                      <span>3 Shortlands, London W6 8DA, UK</span>
                    </div>
                  </li>
                </ul>
              </div>

              {/* Column 3: Legal */}
              <div>
                <p className="text-xs font-medium text-white uppercase tracking-wider mb-3 mt-0">
                  Legal
                </p>
                <ul className="space-y-1.5 mt-0 mb-0 list-none p-0">
                  <li className="mt-0">
                    <a
                      href="/privacy-policy"
                      className="link-underline text-xs text-white/60 hover:text-white/90 transition-colors duration-200 inline-block"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li className="mt-0">
                    <a
                      href="/terms-of-use"
                      className="link-underline text-xs text-white/60 hover:text-white/90 transition-colors duration-200 inline-block"
                    >
                      Terms of Use
                    </a>
                  </li>
                  <li className="mt-0">
                    <a
                      href="/cookie-policy"
                      className="link-underline text-xs text-white/60 hover:text-white/90 transition-colors duration-200 inline-block"
                    >
                      Cookie Policy
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <Separator className="bg-white/10 mb-6" />

            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
              <p className="text-[11px] text-white/40 m-0">
                &copy; {new Date().getFullYear()} TenderAI. All rights reserved.
              </p>
              <div className="flex items-center gap-4 text-[11px] text-white/30">
                <span>GDPR-ready</span>
                <span className="w-px h-3 bg-white/10" />
                <span>Audit trail</span>
                <span className="w-px h-3 bg-white/10" />
                <span>SOC 2</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
